const env = {
    API_GATEWAY_URI: 'https://functions-gateway-6j1g00bm.uk.gateway.dev',
};

export default env;